import { type Row } from '@tanstack/react-table';

const equals = <TData extends Record<string, any> = object>(
  row: Row<TData>,
  id: string,
  filterValue: string | number,
) =>
  row.getValue<string | number>(id).toString().toLowerCase().trim() ===
  filterValue.toString().toLowerCase().trim();

equals.autoRemove = (val: any) => !val;

export const greaterThan = <TData extends Record<string, any> = object>(
  row: Row<TData>,
  id: string,
  filterValue: string | number,
) =>
  !Number.isNaN(+filterValue) &&
  !Number.isNaN(+row.getValue<string | number>(id)) &&
  row.getValue<string | number>(id) !== null
    ? +row.getValue<string | number>(id) > +filterValue
    : false;

greaterThan.autoRemove = (val: any) => !val;

export const greaterThanOrEqualTo = <TData extends Record<string, any> = object>(
  row: Row<TData>,
  id: string,
  filterValue: string | number,
) => equals(row, id, filterValue) || greaterThan(row, id, filterValue);

greaterThanOrEqualTo.autoRemove = (val: any) => !val;

export const lessThan = <TData extends Record<string, any> = object>(
  row: Row<TData>,
  id: string,
  filterValue: string | number,
) =>
  !Number.isNaN(+filterValue) &&
  !Number.isNaN(+row.getValue<string | number>(id)) &&
  row.getValue<string | number>(id) !== null
    ? +row.getValue<string | number>(id) < +filterValue
    : false;

lessThan.autoRemove = (val: any) => !val;

export const lessThanOrEqualTo = <TData extends Record<string, any> = object>(
  row: Row<TData>,
  id: string,
  filterValue: string | number,
) => equals(row, id, filterValue) || lessThan(row, id, filterValue);

lessThanOrEqualTo.autoRemove = (val: any) => !val;

export const between = <TData extends Record<string, any> = object>(
  row: Row<TData>,
  id: string,
  filterValues: [string | number, string | number],
) =>
  ((['', undefined] as any[]).includes(filterValues[0]) || greaterThan(row, id, filterValues[0])) &&
  ((!Number.isNaN(+filterValues[0]) &&
    !Number.isNaN(+filterValues[1]) &&
    +filterValues[0] > +filterValues[1]) ||
    (['', undefined] as any[]).includes(filterValues[1]) ||
    lessThan(row, id, filterValues[1]));

between.autoRemove = (val: any) => !val;

const betweenInclusive = <TData extends Record<string, any> = object>(
  row: Row<TData>,
  id: string,
  filterValues: [string | number, string | number],
) =>
  ((['', undefined] as any[]).includes(filterValues[0]) ||
    greaterThanOrEqualTo(row, id, filterValues[0])) &&
  ((!Number.isNaN(+filterValues[0]) &&
    !Number.isNaN(+filterValues[1]) &&
    +filterValues[0] > +filterValues[1]) ||
    (['', undefined] as any[]).includes(filterValues[1]) ||
    lessThanOrEqualTo(row, id, filterValues[1]));

betweenInclusive.autoRemove = (val: any) => !val;
